import { render, staticRenderFns } from "./CubeLoader.vue?vue&type=template&id=40c23627&scoped=true"
import script from "./CubeLoader.vue?vue&type=script&lang=ts"
export * from "./CubeLoader.vue?vue&type=script&lang=ts"
import style0 from "./CubeLoader.vue?vue&type=style&index=0&id=40c23627&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c23627",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40c23627')) {
      api.createRecord('40c23627', component.options)
    } else {
      api.reload('40c23627', component.options)
    }
    module.hot.accept("./CubeLoader.vue?vue&type=template&id=40c23627&scoped=true", function () {
      api.rerender('40c23627', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Loaders/CubeLoader.vue"
export default component.exports